var render = function () {
  var _vm$order, _vm$order2, _vm$order3, _vm$order4, _vm$order5, _vm$order6, _vm$order7, _vm$order8, _vm$order9, _vm$order9$buyer, _vm$order10, _vm$order10$buyer, _vm$order11, _vm$order11$buyer, _vm$order12, _vm$order12$buyer, _vm$order13, _vm$order13$shippingA, _vm$order14, _vm$order14$shippingA, _vm$order15, _vm$order15$shippingA, _vm$order16, _vm$order16$receiver;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_vm.ready && _vm.order ? _c('div', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("주문결과")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('section', {
    staticClass: "page-section pt-0"
  }, [_vm.resCode == '3001' ? _c('v-data-table', {
    staticClass: "d-flex purchasedetail-table",
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "mobile-breakpoint": "768",
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "item.product",
      fn: function fn(_ref) {
        var _item$product;

        var item = _ref.item;
        return [_c('div', {
          staticClass: "img-wrap border"
        }, [_c('router-link', {
          attrs: {
            "to": "/shop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "width": "100",
            "aspect-ratio": 1 / 1,
            "contain": "",
            "position": "center"
          }
        })], 1)], 1)];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref2) {
        var _item$product2;

        var item = _ref2.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('router-link', {
          attrs: {
            "to": "/shop/products/".concat(item.product._mainProduct || item.product._id)
          }
        }, [_c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))])])], 1)], 1);
      }
    }, {
      key: "item.saleAmount",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.saleAmount.format()) + "원")])])], 1);
      }
    }, {
      key: "item.earnPointAmount",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return _c('v-responsive', {}, [_c('v-flex', [_c('div', {
          staticClass: "mx-2 text-truncate"
        }, [_vm._v(_vm._s(item.earnPointAmount.format()) + "원")])])], 1);
      }
    }], null, false, 3828074124)
  }) : _c('div', [_c('div', [_vm._v("[" + _vm._s(_vm.resCode) + "]")]), _c('div', [_vm._v("결제가 완료되지 않았습니다")])])], 1), _c('section', {
    staticClass: "page-section py-0"
  }, [_c('div', {
    staticClass: "card--primary"
  }, [_c('v-row', {
    staticClass: "row--x-small font-size-14 font-size-md-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("상품("), _c('b', [_vm._v(_vm._s((_vm$order = _vm.order) === null || _vm$order === void 0 ? void 0 : _vm$order.saleAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("배송비("), _c('b', [_vm._v(_vm._s((_vm$order2 = _vm.order) === null || _vm$order2 === void 0 ? void 0 : _vm$order2.shippingAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("도서산간 할증("), _c('b', [_vm._v(_vm._s((_vm$order3 = _vm.order) === null || _vm$order3 === void 0 ? void 0 : _vm$order3.islandAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("적립금 사용("), _c('b', [_vm._v(_vm._s((_vm$order4 = _vm.order) === null || _vm$order4 === void 0 ? void 0 : _vm$order4.pointAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("캐시 사용("), _c('b', [_vm._v(_vm._s((_vm$order5 = _vm.order) === null || _vm$order5 === void 0 ? void 0 : _vm$order5.cashAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("=")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("총 결제 금액")]), _c('b', {
    staticClass: "font-size-20 font-size-md-24 ml-10px ml-md-12px"
  }, [_vm._v(_vm._s(_vm.totalAmount.format()) + "원")])])])], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "30%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문번호")]), _c('td', [_vm._v(_vm._s((_vm$order6 = _vm.order) === null || _vm$order6 === void 0 ? void 0 : _vm$order6.orderNo))]), _c('th', [_vm._v("주문일")]), _c('td', [_vm._v(_vm._s((_vm$order7 = _vm.order) === null || _vm$order7 === void 0 ? void 0 : _vm$order7.createdAt.toDate()))])]), _c('tr', [_c('th', [_vm._v("결제방법")]), _c('td', [_vm._v(_vm._s(_vm.paymentWay))]), _c('th', [_vm._v("주문상태")]), _vm.resCode !== '3001' ? _c('td', [_vm._v(_vm._s('-'))]) : _vm._e(), _vm.resCode === '3001' ? _c('td', [_vm._v(_vm._s((_vm$order8 = _vm.order) === null || _vm$order8 === void 0 ? void 0 : _vm$order8.purchases[0].paymentStatus))]) : _vm._e()]), _c('tr', [_c('th', [_vm._v("입금자명")]), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s((_vm$order9 = _vm.order) === null || _vm$order9 === void 0 ? void 0 : (_vm$order9$buyer = _vm$order9.buyer) === null || _vm$order9$buyer === void 0 ? void 0 : _vm$order9$buyer.name))])])])]), _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("주문하신 분")])]), _c('table', {
    staticClass: "table--default"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  })]), _c('tr', [_c('th', [_vm._v("주문하신분")]), _c('td', [_vm._v(_vm._s((_vm$order10 = _vm.order) === null || _vm$order10 === void 0 ? void 0 : (_vm$order10$buyer = _vm$order10.buyer) === null || _vm$order10$buyer === void 0 ? void 0 : _vm$order10$buyer.name))])]), _c('tr', [_c('th', [_vm._v("연락처")]), _c('td', [_vm._v(_vm._s((_vm$order11 = _vm.order) === null || _vm$order11 === void 0 ? void 0 : (_vm$order11$buyer = _vm$order11.buyer) === null || _vm$order11$buyer === void 0 ? void 0 : _vm$order11$buyer.phone))])]), _c('tr', [_c('th', [_vm._v("이메일")]), _c('td', [_vm._v(_vm._s((_vm$order12 = _vm.order) === null || _vm$order12 === void 0 ? void 0 : (_vm$order12$buyer = _vm$order12.buyer) === null || _vm$order12$buyer === void 0 ? void 0 : _vm$order12$buyer.email))])]), _c('tr', [_c('th', [_vm._v("주소")]), _c('td', [_vm._v(_vm._s("[".concat((_vm$order13 = _vm.order) === null || _vm$order13 === void 0 ? void 0 : (_vm$order13$shippingA = _vm$order13.shippingAddress) === null || _vm$order13$shippingA === void 0 ? void 0 : _vm$order13$shippingA.postcode, "] ").concat((_vm$order14 = _vm.order) === null || _vm$order14 === void 0 ? void 0 : (_vm$order14$shippingA = _vm$order14.shippingAddress) === null || _vm$order14$shippingA === void 0 ? void 0 : _vm$order14$shippingA.address1, " ").concat((_vm$order15 = _vm.order) === null || _vm$order15 === void 0 ? void 0 : (_vm$order15$shippingA = _vm$order15.shippingAddress) === null || _vm$order15$shippingA === void 0 ? void 0 : _vm$order15$shippingA.address2)))])]), _c('tr', [_c('th', [_vm._v("받는사람 연락처")]), _c('td', [_vm._v(_vm._s((_vm$order16 = _vm.order) === null || _vm$order16 === void 0 ? void 0 : (_vm$order16$receiver = _vm$order16.receiver) === null || _vm$order16$receiver === void 0 ? void 0 : _vm$order16$receiver.phone))])])])]), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "outlined": "",
      "color": "gray",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("홈으로가기")])])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "to": "/mypage/shop/purchases"
    }
  }, [_vm._v("주문배송확인")])], 1)], 1)], 1)])])]) : _vm._e(), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref5) {
        var postcode = _ref5.postcode,
            address = _ref5.address;
        _vm.order.shippingAddress.postcode = postcode;
        _vm.order.shippingAddress.address1 = address;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }